export * from './lab-req-bc/lab-req-bc.component';
export * from './lab-req-bc/data';

export * from './lab-req-qc/lab-req-qc.component';
export * from './lab-req-qc/data';

export * from './lab-req-sk/lab-req-sk.component';
export * from './lab-req-sk/data';

export * from './lab-req-ab/lab-req-ab.component';
export * from './lab-req-ab/data';

export * from './lab-req-nf/lab-req-nf.component';
export * from './lab-req-nf/data';

export * from './lab-req-on/lab-req-on.component';
export * from './lab-req-on/data';

export * from './lab-req-base/lab-req-base.component';

export * from './lab-req-v1/lab-req.module';
export * as LabReqV1 from './lab-req-v1/lab-req-base/lab-req-base.component';
export {
  LabReqBaseComponent as LabReqBaseComponentV1,
  LabReqAB as LabReqABV1,
  LabReqQC as LabReqQCV1,
  LabReqON as LabReqONV1,
  LabReqBC as LabReqBCV1
} from './lab-req-v1/lab-req-base/lab-req-base.component';
export * from './lab-req-v1/lab-req-view/lab-req-view.component';
export * from './lab-req-v1/lab-req-base/lab-req-base.module';
